import React from "react";
import "../App.css";
import { Project } from "../types";
import mysteerioImage from "../img/mysteerio.png";

export const mysteerio: Project = {
  title: "Mysteerio",
  image: mysteerioImage,
  description:
    " Mysteerio is a Web development company from Helsinki, Finland.\nI was a part of the development team that made this version of the website. Now it is a legacy version. It was developed from scratch as a Drupal theme.\nRole: Front-end Developer, Back-end Developer, Designer.",
  link: "https://mysteerio.fi/",
};

const MysteerioPage: React.FC = () => {
  return (
    <>
    <a href="/" id="logo">
        MP
      </a>
      <div className="projectPage">
        <div className="leftPart">
          <img src={mysteerio.image} alt={mysteerio.title} />
        </div>
        <div className="rightPart">
          <h1>{mysteerio.title}</h1>
          <p>{mysteerio.description}</p>
          <a href={mysteerio.link} target="_blank" rel="noopener noreferrer">
            Visit the website
          </a>
        </div>
      </div>
    </>
  );
};

export default MysteerioPage;
